module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_cat_FR.1fae5185.png";